// The admin E-Mails screen's calls to the backend, all under /api/cms/emails/** (the admin area:
// admins and the team). Kept in one module so the screen can be tested against a mocked API (the
// tests mock this module and assert on the payloads, not on axios), the same shape
// PersonAdminApi and ProgramAdminApi have.
//
//   GET /api/cms/emails/types      -> [{key, group}]  every MailType the log can hold
//   GET /api/cms/emails/log        -> {total, rows}
//   GET /api/cms/emails/schedules  -> the three automatic types with their settings and days
//
// The log query is 0-based: page, size (50 by default, 200 at most), type, eventId, q, status,
// trigger, from and to (Vienna dates, YYYY-MM-DD, both inclusive), newest first.
import api from '../../utils/authUtils';

// The type catalogue, for the type filter's dropdown.
export const fetchTypes = () => api.get('/api/cms/emails/types').then((r) => r.data);

// One page of the sent log, the filters as the backend takes them (emailAdminModel.logParams).
export const fetchLog = (params) => api.get('/api/cms/emails/log', { params }).then((r) => r.data);

// program.EventOptionsController: the event filter's dropdown, the same route the program and people
// screens use.
export const fetchEventOptions = () => api.get('/api/cms/events/options').then((r) => r.data);

// The template catalogue and one template (email.EmailTemplatesController). A save answers the saved
// template; a refused save is a 400 whose body is {problems: [...]}.
export const fetchTemplates = () => api.get('/api/cms/emails/templates').then((r) => r.data);

export const fetchTemplate = (key) => api.get(`/api/cms/emails/templates/${key}`).then((r) => r.data);

export const saveTemplate = (key, subject, html) => api
  .put(`/api/cms/emails/templates/${key}`, { subject, html }).then((r) => r.data);

export const resetTemplate = (key) => api.delete(`/api/cms/emails/templates/${key}`).then((r) => r.data);

// The unsaved text rendered with the backend's made-up person and event.
export const previewTemplate = (key, subject, html) => api
  .post(`/api/cms/emails/templates/${key}/preview`, { subject, html }).then((r) => r.data);

// The automatic emails' schedules (email.EmailSchedulesController). Every write answers the whole
// schedule of that kind; a refused write is a 400 whose body is {problems: [...]}.
export const fetchSchedules = () => api.get('/api/cms/emails/schedules').then((r) => r.data);

// {enabled, sendTime, intervalDays?, maxCount?}: the two numbers only for the repeating type.
export const updateSchedule = (kind, body) => api
  .put(`/api/cms/emails/schedules/${kind}`, body).then((r) => r.data);

// {daysBeforeStart, copyFromStepId}: the new day starts with a copy of that day's text.
export const addScheduleStep = (kind, body) => api
  .post(`/api/cms/emails/schedules/${kind}/steps`, body).then((r) => r.data);

// {daysBeforeStart}: the same day keeps its id, so people it reached are not mailed again.
export const changeScheduleStep = (kind, id, body) => api
  .put(`/api/cms/emails/schedules/${kind}/steps/${id}`, body).then((r) => r.data);

// A removed day's history stays; its saved template text is deleted.
export const removeScheduleStep = (kind, id) => api
  .delete(`/api/cms/emails/schedules/${kind}/steps/${id}`).then((r) => r.data);

// What the automatic emails would send in the next days (email.EmailUpcomingController):
// {days, from, to, projection, schedules, rows}; read only. `days` is 1 to 31 (the screen offers
// 7, 14 and 31). Each row carries its people's ids and display names, never an address.
export const fetchUpcoming = (days) => api
  .get('/api/cms/emails/upcoming', { params: { days } }).then((r) => r.data);
